import React, { useContext } from "react";
import { StratificationTableContext } from "./PatientHospitalPresentStratificationTable";

export const PatientHospitalPresentStratificationTableHead = () => {
  const { headerGroups } = useContext(StratificationTableContext);

  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          <th>Ž / PH</th>
          {headerGroup.headers.map((column) => (
            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
